import "./styles";

export * as analytics from "../Features/Analytics/analytics";
export * as app from "client_legacy/ndaw/app";
export * as browserTitle from "client_legacy/ndaw/browserTitle";
export * as culture from "client_legacy/ndaw/culture";
export * as globalAlertsContainer from "../Features/Alerts/GlobalAlertBarContainer";
export * as hashNavigation from "../Features/Navigation/EnvironmentHashNavigation";
export * as welcomeWizard from "../Features/WelcomeWizard/WelcomeWizard";;
export * as menus from "client_legacy/ndaw/menus";
export * as mobile from "client_legacy/ndaw/mobile";
export * as mobileBar from "../Features/Layout/MobileBar/MobileBar";
export * as navigator from "client_legacy/ndaw/navigator";
export * as teamsEmbedNavigationHandler from "client/TeamsEmbed/teamsEmbedNavigationHandler";
export * as titleBar from "client/Features/Layout/TitleBar/TitleBar";
export * as touch from "client_legacy/ndaw/touch";
export * as workspaceAbilitiesStatusProvider from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
export * as globalNavigationSidebar from "../Features/Layout/GlobalNavigationSidebar/GlobalNavigationSidebar";

export * as adminPageSignIn from "../Features/AdminPage/SignIn";
export * as instanceOperatorSignIn from "../Features/InstanceOperator/SignIn";
export * as appLinksNavigation from "../Features/Apps/AppLink/GoPage";
export * as configureSingleSignOn from "../Features/AdminPage/ConfigureSingleSignOn";
export * as documents from "../Features/Documents/DocumentPage";
export * as embedTileGroup from "../Features/Workspace/EmbedTileGroup/EmbedTileGroup";
export * as fullScreenDocument from "client_legacy/Documents/fullScreenDocument";
export * as landing from "../Features/Landing/Page";
export * as logDocuments from "../Features/InstanceOperator/Logs/Page";
export * as requestEmergencyAdminAccess from "../Features/AdminPage/RequestEmergencyAdminAccess";
export * as clearedSharedData from "../Features/InstanceOperator/ClearSharedData";
export * as instanceOperatorIndex from "../Features/InstanceOperator/MenuPage";
export * as environments from "../Features/InstanceOperator/Environments";
export * as publicPagePoweredBy from "../Features/PublicPage/PublicPagePoweredBy";
export * as spaEndpoint from "../Features/Infrastructure/SpaEndpoint";
export * as supportPage from "../Features/Support/Page";
export * as signInPage from "../Features/Authentication/SignInPage";
export * as signOutPage from "../Features/Authentication/SignOutPage";
export * as oauth2SecretKeyExpirationAlert from "../Features/Layout/OAuth2SecretKeyExpirationAlert";
export * as officeDocumentsOpenPreference from "client_legacy/Documents/officeDocumentsOpenPreference";